/**
 * Environment configuration
 */
export const env = {
    withCredentials: true,
    production: true,
    redirect: true,
    api: '',
    url_prefix: '',
    publicKey: '9D1ED166AA7C417D8EEBB25F8B0AE666',
    publicKeyExtras: 'jaskula',
    userCode: 'nitsnets',
    email: '',
    urls: [
        {
            // balanceador
            prefix: 'https://lb.gruposoledad.com',
            // prefix: 'https://lbmaestro.gruposoledad.net',
            sufix: '/restBusinessDelegate/restBusinessDelegate.aspx',
        },
        {
            // nodo de ono
            prefix: 'https://b2bnodo1.gruposoledad.net', // la direcci�n buena es
            sufix: '/restBusinessDelegate/restBusinessDelegate.aspx',
        },
        {
            // nodo de kio
            prefix: 'https://b2bnodo2.gruposoledad.net', // la direcci�n buena es
            sufix: '/restBusinessDelegate/restBusinessDelegate.aspx',
        },
        {
            prefix: 'https://b2bnodo3.gruposoledad.net',
            sufix: '/restBusinessDelegate/restBusinessDelegate.aspx',
        },
        {
            // sqlserverb2b
            prefix: 'http://servicios.gruposoledad.net:7080',
            sufix: '/restBusinessDelegate/restBusinessDelegate.aspx',
        },
        {
            // sqlserverb2b por data internet
            prefix: 'http://datainternet.gruposoledad.net:7080',
            sufix: '/restBusinessDelegate/restBusinessDelegate.aspx',
        },
    ],
    linkedApps: {
        fleetOnTime: 'http://b2b.gruposoledad.net:7011/flex_fleetOnTime/flex_fleetOnTime.html?params=%PARAMS%',
        puntos: 'http://www.gruposoledad.com/b2b/html/swf/test_consulta_puntos.swf?params=%PARAMS%',
        incidencias: 'http://www.gruposoledad.com/b2b/html/swf/flex_moduleIncidencias.swf?params=%PARAMS%',
        presupuestos:
            'http://servicios.gruposoledad.net:7080/' +
            'presupuestosB2B/VisualJSApp/Default.aspx?params=%PARAMS%&articulos=%ARTICLES%&guid=%GUID%',
    },

    urlBackgroundLoginPrefix: 'https://lb.gruposoledad.com/flex/images/b2b/design/',

    currentLang: 'es',
    allowedEntities: [1, 18, 30, 38, 49],
    // allowedEntitiesComercial: [9001, 16],
    acceptedLanguages: {},
    // {     'Español'   : 'es',
    //     'Português' : 'pt',
    //     'Francés'   : 'fr',
    //     'Euskera'   : 'eu'
    // }

    dbTimeout: 60000, // timeout en segundos para la ejecución de los servicios web
    dbTestTimeout: 5000, // timeout en segundos para la comprobación de que el servicio web está activo
    useCache: true, // indica si usamos cache para almacenar respuestas de los servicios
    cacheTTL: 600, // tiempo de caducidad de la cache, ponemos en 10 minutos 600 segundos
    servicesConfig: {
        // estos servicios son cacheados, los que no están indicados NO SE CACHEAN.

        b2bNew_dbo_HTML_MarcasBusqueda: {
            serviceName: 'b2bNew.dbo.HTML_MarcasBusqueda',
            cacheable: true,
            cacheTTL: 600, // Duración de la cache en segundos
        },
        b2bNew_dbo_HTML_PedidosEstados: {
            serviceName: 'b2bNew.dbo.HTML_PedidosEstados',
            cacheable: true,
        },
        b2bNew_dbo_HTML_ClientesDirEnvio: {
            serviceName: 'b2bNew.dbo.HTML_ClientesDirEnvio',
            cacheable: true,
        },
        b2bNew_dbo_HTML_ClientesBusqueda: {
            serviceName: 'b2bNew.dbo.HTML_ClientesBusqueda',
            cacheable: true,
        },
        b2bNew_dbo_HTML_FormasPago: {
            serviceName: 'b2bNew.dbo.HTML_FormasPago',
            cacheable: true,
        },
        b2bNew_dbo_HTML_TipoVehiculosBusqueda: {
            serviceName: 'b2bNew.dbo.HTML_TipoVehiculosBusqueda',
            cacheable: true,
        },

        b2bNew_dbo_HTML_Contacto: {
            serviceName: 'b2bNew.dbo.HTML_Contacto',
            cacheable: true,
        },
        b2bNew_dbo_HTML_MedidasMasBuscadas: {
            serviceName: 'b2bNew.dbo.HTML_MedidasMasBuscadas',
            cacheable: true,
        },
        b2bNew_dbo_HTML_OpcionesCaracteristicas: {
            serviceName: 'b2bNew.dbo.HTML_OpcionesCaracteristicas',
            cacheable: true,
        },
        b2bNew_dbo_HTML_ArticulosBusquedaMedida: {
            serviceName: 'b2bNew.dbo.HTML_ArticulosBusquedaMedida',
            cacheable: true,
        },
        b2bNew_dbo_HTML_ArticulosBusquedaOrden: {
            serviceName: 'b2bNew.dbo.HTML_ArticulosBusquedaOrden',
            cacheable: true,
        },
        b2bNew_dbo_HTML_PortadaLeer: {
            serviceName: 'b2bNew.dbo.HTML_PortadaLeer',
            cacheable: true,
        },
        b2bNew_dbo_HTML_AlmacenesAgenciasHoras: {
            serviceName: 'b2bNew.dbo.HTML_AlmacenesAgenciasHoras',
            cacheable: true,
        },
    },
    redirecciones: [
        {
            origin: 'www.gruposoledad.com/b2b/debug/current',
            destination: 'https://b2btest.current.gruposoledad.com/index.html',
        },
        {
            origin: 'www.gruposoledad.com/b2b/debug/new',
            destination: 'https://b2btest.new.gruposoledad.com/index.html',
        },
        // {
        //     origin:'localhost:4200/',
        //     destination: 'http://test.gsoledad2018.com/b2b/current/index.html'
        // },
        {
            origin: 'www.gruposoledad.com/b2b/new',
            destination: 'https://b2b.new.gruposoledad.com/index.html',
        },
        {
            origin: 'www.gruposoledad.com/b2b/current',
            destination: 'https://b2b.current.gruposoledad.com/index.html',
        },
    ],
    SENTRY_ORG: 'nitsnets',
    SENTRY_PROJECT: 'gruposoledad-b2b-front',
    SENTRY_AUTH_TOKEN: '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',
};
